import { ContactCard } from '@dap/common/ui';
import { useSanityContextActions } from '@dap/sanity/utils';
import { Person } from '@dap/sanity/types';
import { Grid, Typography, Card, SxProps, useTheme } from '@mui/material';

interface ContactListProps {
  contacts: Person[];
  title?: string;
  noPadding?: boolean;
}

export function ContactList({ contacts, title, noPadding = false }: ContactListProps) {
  const { getImageUrlBuilder } = useSanityContextActions();
  const theme = useTheme();

  if (!contacts.length) return null;

  const sx: SxProps = noPadding
    ? {
        padding: 0,
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(0),
        },
      }
    : {};

  return (
    <Card sx={sx}>
      {title && (
        <Typography variant="h4" sx={{ marginBottom: 3 }}>
          {title}
        </Typography>
      )}
      <Grid
        display="grid"
        container
        gridTemplateColumns="repeat(auto-fill, minmax(min(100%, max(250px, 350px)), 1fr))"
        gap={2}
        width="100%"
      >
        {contacts.map((contact, index) => (
          <Grid key={contact.email}>
            <ContactCard
              key={index}
              {...contact}
              userPicture={
                contact.image
                  ? getImageUrlBuilder(contact?.image)
                      .width(72 * 4)
                      .height(72 * 4)
                      .quality(80)
                      .url()
                  : undefined
              }
              phoneNumber={contact.phone}
              jobTitle={contact.jobtitle}
            />
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}
